import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[outSideClick]'
})
export class OutSideClickDirective {
  @Output() outSideClick = new EventEmitter();
  constructor(private readonly eleRef: ElementRef) { }
  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (!this.eleRef.nativeElement.contains(event.target)) {
      this.outSideClick.emit();
    }
  }
}

@Directive({
  selector: '[NoLeadingSpaceDirective]'
})
export class NoLeadingSpaceDirective {

  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const trimmedValue = value.replace(/^\s+/, '');
    if (trimmedValue !== value) {
      this.el.nativeElement.value = trimmedValue;
      // Emit input event only if value was changed to avoid unnecessary triggering
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
